import { render, staticRenderFns } from "./add-fee-template.vue?vue&type=template&id=7bb362d8&lang=pug"
import script from "./add-fee-template.vue?vue&type=script&lang=js"
export * from "./add-fee-template.vue?vue&type=script&lang=js"
import style0 from "./add-fee-template.vue?vue&type=style&index=0&id=7bb362d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports